import $ from 'jquery';
import Marquee from './marquee';

const NO_ANIMATIONS = (globalThis as any).NO_ANIMATIONS;

/*
 * Phone Side Menu
 */

const $phone_side_menu = $('#phone-side-menu'),
      $icon_menu = $('#icon-menu'),
      $icon_close_menu = $('#icon-close-menu');

$icon_menu.on('click touch', function(e) {
    e.preventDefault();
    $('#phone-side-menu').addClass('show');
    $('body').css('overflow', 'hidden');
});

$icon_close_menu.on('click touch', function(e) {
    e.preventDefault();
    $phone_side_menu.removeClass('show');
    $('body').css('overflow', 'auto');
});

// Menu schließen, wenn man außerhalb oder link klickt:
$('body').on('click touch', (e) => {
    if ($phone_side_menu.hasClass('show')) {
        if ($(e.target).is('a') || e.target.id == 'phone-side-menu') {
            $phone_side_menu.removeClass('show');
            $('body').css('overflow', 'auto');
        }
    }
});

// newsletter discount teaser (.only-phone) anzeigen/verstecken &marquee starten:
const $marqueeEles = $('body > header .effect-marquee');
$marqueeEles.each((i, marquee) => {
    new Marquee(marquee);
    if (NO_ANIMATIONS) return;
    $marqueeEles.addClass('effect-marquee-show');
});
$(window).on('scroll', (e) => {
    if (window.scrollY > 10) {
        $('body').addClass('hide-discount');
    } else {
        $('body').removeClass('hide-discount');
    }
});

/*
 * Desktop-Menü
 */

const body = document.querySelector<HTMLElement>(`body`)!;
const layer = document.querySelector<HTMLElement>(`#menu_layer`);
const menuIcon = document.querySelector<HTMLElement>(`body > header > nav .menu-icon`);
const closeArea = document.querySelector<HTMLElement>(`body > header > nav .close-area`);
const menuLinks = document.querySelectorAll<HTMLAnchorElement>(`#menu_layer a`);

menuIcon?.addEventListener('click', function(e) {
    menu.toggle();
});

// Menü bei Mouseover öffnen
menuIcon?.addEventListener('mouseenter', function(e) {
    menu.open();
});
closeArea?.addEventListener('mousemove', function(e) {
    menu.close();
});

menuLinks.forEach(el => {
    el.addEventListener('click', function(e) {
        e.preventDefault();
        const {href} = el;
        if(href) {
            const navigate = () => location.href = href;
            if(href[0] === '#')
                navigate();
            else
                setTimeout(navigate, 500);
        }
        menu.close();
    });
});

const menu = {
    open() {
        if(menu.isOpen())
            return Promise.resolve();
        return new Promise(resolve => {
            layer?.addEventListener('transitionend', resolve, {once: true});
            body.classList.add('menu-open');
        });
    },

    close() {
        if(!menu.isOpen())
            return Promise.resolve();
        return new Promise(resolve => {
            layer?.addEventListener('transitionend', resolve, {once: true});
            body.classList.remove('menu-open');
        });
    },

    toggle() {
        return new Promise(resolve => {
            layer?.addEventListener('transitionend', resolve, {once: true});
            body.classList.toggle('menu-open');
        });
    },

    isOpen(): boolean {
        return body.classList.contains('menu-open');
    },
};

export default menu;
